module.exports = __webpack_public_path__ + "static/media/zip-icon.72544738.svg";